import React from 'react'
import './intro.css'

const Introduction = () => {
  return (
    <div className='intro-section' data-aos="fade-up">
        <h1>
            Introduction
        </h1>
        <p>
            I am a tech enthusiast, foodie, loves to 
            draw portraits and a sports enthusiast.
            Professionally I am a front-end focused full stack developer.
            I'm quiet confident, and working
            on improving my development techniques
            and also a little bit on designing.I'm a self
            learner who is motivated by daily challenges
            and has been looking forward to innovate.
        </p>
    </div>
  )
}

export default Introduction